module.exports = __webpack_public_path__ + "static/media/client_nav_icon.08a51d06.svg";